<template>
	<section>
		<floating-alert-vue
			:message="alertMessage"
			:show="alertShow"
			:type="alertType"
		></floating-alert-vue>
		<loader-vue :dialog="loading"></loader-vue>

		<div v-if="client.subscription" class="sub-card">
			<div class="sub-icon-box">
				<v-icon size="20" color="white">mdi-playlist-check</v-icon>
			</div>
			<div class="sub-info">
				<p class="sub-label" v-html="client.subscription.label"></p>
				<div class="sub-details">
					<span class="sub-badge sub-badge-blue">{{ client.subscription.type }}</span>
					<span class="sub-detail-text">
						<v-icon size="12" color="#9ca3af">mdi-cash</v-icon>
						{{ client.subscription.price }} FCFA
					</span>
					<span class="sub-detail-text">
						<v-icon size="12" color="#9ca3af">mdi-calendar-range</v-icon>
						{{ client.subscription.duration }} jours
					</span>
				</div>
				<p class="sub-date">
					<v-icon size="12" color="#9ca3af">mdi-calendar-check</v-icon>
					Date d'inscription : {{ client.inscriptionDate }}
				</p>
			</div>
			<div class="sub-checkbox">
				<v-checkbox
					v-model="registered"
					label="Inscrit"
					color="#c62828"
					hide-details
					dense
				></v-checkbox>
			</div>
		</div>
		<v-alert type="warning" dense text rounded="xl" v-else>
			Aucun abonnement attribué à ce client.
		</v-alert>
	</section>
</template>

<script>
import services from "@/services";
import FloatingAlertVue from "@/components/FloatingAlert.vue";
import LoaderVue from "@/components/Loader.vue";
export default {
	props: ["client"],
	components: { FloatingAlertVue, LoaderVue },
	data() {
		return {
			registered: this.client.registered,
			alertMessage: "",
			alertShow: false,
			alertType: "",
			loading: false,
		};
	},
	watch: {
		registered(checked) {
			this.alertShow = false;
			this.loading = true;
			services
				.updateInscription(this.client._id, checked)
				.then(() => {
					this.loading = false;
					this.alertMessage = "Inscription modifiée";
					this.alertShow = true;
					this.alertType = "green";
				})
				.catch((err) => {
					console.log(err);
					this.loading = false;
					this.alertMessage = "Echec de l'inscription";
					this.alertShow = true;
					this.alertType = "red";
				});
		},
	},
};
</script>

<style scoped>
.sub-card {
	display: flex;
	align-items: flex-start;
	gap: 16px;
	padding: 16px;
	border-radius: 16px;
	background: #f9fafb;
	border: 1px solid #f3f4f6;
	font-family: Montserrat, sans-serif;
}
.sub-icon-box {
	width: 44px;
	height: 44px;
	border-radius: 12px;
	background: #1565c0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.sub-info {
	flex: 1;
}
.sub-label {
	font-size: 0.95rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 8px;
}
.sub-details {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 6px;
}
.sub-badge {
	font-size: 0.68rem;
	font-weight: 700;
	padding: 2px 10px;
	border-radius: 50px;
	letter-spacing: 0.3px;
}
.sub-badge-blue {
	background: #dbeafe;
	color: #1565c0;
}
.sub-detail-text {
	font-size: 0.75rem;
	color: #6b7280;
	display: flex;
	align-items: center;
	gap: 3px;
}
.sub-date {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	display: flex;
	align-items: center;
	gap: 4px;
}
.sub-checkbox {
	flex-shrink: 0;
}
</style>
